import { EXERCISE_FORCE } from '@gymaholic/packages'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { invertObjectUtil } from 'packages/src'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  force: {
    id: 'Exercise.force',
    defaultMessage: 'It’s a {exerciseType} exercise that uses {force} force.'
  }
})

export const getForceString = ({
  force,
  exerciseType,
  intl
}) => {
  if (!force) {
    return ''
  }

  const forceLabel = invertObjectUtil(EXERCISE_FORCE)[force]
    .toLowerCase()
    .replace('_', ' ')

  return formatMessageIntlUtil(intl, messages.force, {
    exerciseType,
    force: forceLabel
  })
}
